import _ from "lodash";
import moment from "moment/moment";
import { convertedEquals, convertToType, isPrimitiveEmpty, versionNow } from "./HistoryUtils";

function processDeletionsFromExistingHistory(visibleHistoryEntries, anamnesisDtoValue, result ){
    visibleHistoryEntries?.forEach((historyEntry) => {
        if (!anamnesisDtoValue.map((row) => row.questionId).includes(historyEntry.anamnesisQuestion.id)) {
            //TODO LM: check version too!! we only want to update on current version
            console.debug('diff: marking for deletion - ', historyEntry.anamnesisQuestion.id);
            result.push({
                ...historyEntry,
                anamnesisQuestion: {
                    ...historyEntry.anamnesisQuestion,
                    deletedAtVersion: versionNow(),
                },
            });
        }
    });
}

export function addComplexDiffToResults(key, anamnesisDtoValue, complexHistory, result, supplementalQuestionData) {
    const visibleHistoryEntries = complexHistory[key]?.filter((item) => !item.anamnesisQuestion.deletedAtVersion);
    const newResult = [];
    processDeletionsFromExistingHistory(visibleHistoryEntries, anamnesisDtoValue, newResult);
    anamnesisDtoValue.forEach((row) => {
        const matchingHistoryEntry = visibleHistoryEntries?.find(
            (item) => item.anamnesisQuestion.id === row.questionId,
        );
        if (!matchingHistoryEntry) {
            console.debug('diff: adding new entry for - ', key);
            const entry = complexAnamnesisDtoValueToNewHistoryEntry(key, row, supplementalQuestionData);
            if (!_.isEmpty(entry.anamnesisSubData)) {
                newResult.push(entry);
            }
        } else {
            if (isAnySubDataDifferent(matchingHistoryEntry, row)) {
                if (versionNow() === matchingHistoryEntry.anamnesisQuestion.version) {
                    console.debug('diff: sub data was different on same version, updating - ', key);
                    const entry = complexAnamnesisDtoValueToUpdatedHistoryEntry(
                        row,
                        matchingHistoryEntry,
                        supplementalQuestionData,
                    );
                    if (!_.isEmpty(entry.anamnesisSubData)) {
                        newResult.push(entry);
                    }
                } else {
                    console.debug('diff: sub data was different on old version, adding new, marking old as deleted - ', key);
                    newResult.push({
                        ...matchingHistoryEntry,
                        anamnesisQuestion: {
                            ...matchingHistoryEntry.anamnesisQuestion,
                            deletedAtVersion: versionNow(),
                        },
                    });
                    const entry = complexAnamnesisDtoValueToNewHistoryEntry(key, row, supplementalQuestionData);
                    if (!_.isEmpty(entry.anamnesisSubData)) {
                        newResult.push(entry);
                    }
                }
            }
        }
    });
    if (newResult.length !== 0) {
        result[key] = newResult;
    }
}

function isAnySubDataDifferent(historyEntry, anamnesisDtoValue) {
    //NOTE LM: anamnesisDtoValue will have the questionId the rest is data
    const { questionId, ...dtoValues } = anamnesisDtoValue;
    const dtoValueKeys = Object.keys(dtoValues || {}).filter((key) => dtoValues[key] !== null && dtoValues[key] !== undefined);
    if (Object.keys(historyEntry.anamnesisSubData || {})?.length !== dtoValueKeys.length) {
        return true;
    } else {
        return dtoValueKeys.some((key) => {
            const result = !convertedEquals(historyEntry.anamnesisSubData[key]?.answer, anamnesisDtoValue[key]);
            if(result) {
                console.debug('DIFFERENCE: ', key, ' history: ', historyEntry.anamnesisSubData[key]?.answer, ' newvalues: ', anamnesisDtoValue[key]);
            }
            return result;
        })
    }
}

function complexAnamnesisDtoValueToUpdatedHistoryEntry(
    anamnesisDtoValue,
    matchingHistoryEntry,
    { patientId, role, userId },
) {
    const { questionId, ...subData } = anamnesisDtoValue;
    return {
        anamnesisQuestion: {
            ...matchingHistoryEntry.anamnesisQuestion,
            modificationDate: moment().toISOString(),
        },
        anamnesisSubData: _.isEmpty(Object.keys(subData))
            ? {}
            : Object.keys(subData).reduce((acc, subDataKey) => {
                const history = matchingHistoryEntry.anamnesisSubData[subDataKey];
                const id = !("" + questionId).includes("new") && { anamnesisQuestionId: questionId };
                const current = !isPrimitiveEmpty(subData[subDataKey]) && {
                        [subDataKey]: {
                            ...history,
                            ...id,
                            question: subDataKey,
                            answer: subData[subDataKey],
                            patientId,
                        },
                    };
                return {
                    ...acc,
                    ...current,
                };
            }, {}),
    };
}

function complexAnamnesisDtoValueToNewHistoryEntry(key, anamnesisDtoValue, { patientId, role, userId }) {
    const { id, questionId, ...subData } = anamnesisDtoValue;
    return {
        anamnesisQuestion: {
            patientId,
            question: key,
            answer: "SUB_DATA",
            version: versionNow(),
            modificationDate: moment().toISOString(),
        },
        anamnesisSubData: _.isEmpty(Object.keys(subData))
            ? {}
            : Object.keys(subData).reduce(
                (acc, subDataKey) => ({
                    ...acc,
                    ...(!isPrimitiveEmpty(subData[subDataKey]) && {
                            [subDataKey]: {
                                ...(!("" + questionId).includes("new") && { anamnesisQuestionId: questionId }),
                                question: subDataKey,
                                answer: subData[subDataKey],
                                patientId,
                            },
                        }),
                }),
                {},
            ),
    };
}
